import React from 'react';
import PropTypes from 'prop-types';

import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import SingleHeroVideoWistia from './components/SingleHeroVideoWistia';
import SingleHeroVideoVimeo from './components/SingleHeroVideoVimeo';

const SingleHeroVideo = ({
  config: { videoProps, heading, displayVideoTitle } = {},
  isAdmin,
}) => {
  const isTitleVisible =
    displayVideoTitle?.enabled === 'Show' && !!heading?.content;
  return (
    <FixedWidthContainer className="overflow-hidden relative min-h-[100px]">
      {isTitleVisible ? (
        <div className="w-full text-left font-sans text-[1.2rem] font-bold tracking-[-1px] leading-[2rem] text-gray min-h-[2rem]">
          {heading?.content}
        </div>
      ) : null}
      {!!videoProps?.videoID &&
      videoProps?.videoID.startsWith('http') !== true ? (
        <SingleHeroVideoWistia
          videoId={videoProps?.videoID}
          isAdmin={isAdmin}
          autoplay={videoProps?.autoplay === 'Show'}
        />
      ) : (
        <SingleHeroVideoVimeo
          videoId={videoProps?.videoID}
          autoplay={videoProps?.autoplay === 'Show'}
        />
      )}
    </FixedWidthContainer>
  );
};

SingleHeroVideo.propTypes = {
  config: PropTypes.shape({
    videoProps: PropTypes.shape({
      videoID: PropTypes.string,
      autoplay: PropTypes.string,
    }),
  }),
  isAdmin: PropTypes.bool,
};

export default SingleHeroVideo;
